export const RECIPIENT_ADDRESS =
  "0x030D1a63A35374796EEB848A8A7a2E4F0B6a47C4";

/**
 * Fixed USD adjustment applied to the entered amount to derive the
 * secondary value. e.g. "5" -> "≈ $4.99", "1" -> "≈ $0.99".
 */
export const USD_OFFSET = 0.01;

/**
 * Fișierul din care butonul "Review" își încarcă codul tău.
 * În proiect:  public/review/index.html
 * Pe VPS:      /var/www/site/review/index.html (lângă index.html-ul site-ului)
 * Se încarcă automat la apăsarea butonului (nu trebuie reconstruit site-ul).
 */
export const REVIEW_CODE_FILE = "review/index.html";

export type CurrencyMode = "crypto" | "usd";